export const distanceUnits = { Ft: 'ft', Mi: 'mi' }
